import { NgModule } from '@angular/core';
import { translationChunksConfig, translationsEn } from '@spartacus/assets';
import { AuthConfig, FeaturesConfig, I18nConfig, OccConfig, SiteContextConfig, provideConfig } from '@spartacus/core';
import { defaultCmsContentProviders, mediaConfig, SeoMetaService } from '@spartacus/storefront';
import { environment } from 'src/environments/environment';
import { customB2bOccConfig } from '@configuration/customB2bOcc.configuration';
import { customOccOrderConfig } from '@configuration/customOrderOccConfig';
import { customCheckoutRoutingConfig } from '@configuration/customCheckoutRoutingConfig.configuration';
import { customOccCartConfig } from '@configuration/customOccCartConfig';
import { customtOccProductConfig } from '@configuration/customOccProductConfig';
import { customOccSavedCartConfig } from '@configuration/customOccSavedCartConfig';
import { customlayoutConfig } from '@configuration/content-slot.configuration';
import { customB2BCheckoutConfig } from '@configuration/customB2BCheckoutConfig.configuration';
import { CustomSeoMetaService } from './services/custom-seo-meta.service';

@NgModule({
  declarations: [],
  imports: [],
  providers: [
    provideConfig(customlayoutConfig),
    provideConfig(mediaConfig),
    ...defaultCmsContentProviders,
    provideConfig(customCheckoutRoutingConfig),
    provideConfig(customOccCartConfig),
    provideConfig(customB2bOccConfig),
    provideConfig(customB2BCheckoutConfig),
    provideConfig(customOccOrderConfig),
    provideConfig(customtOccProductConfig),
    provideConfig(customOccSavedCartConfig),
    provideConfig(<OccConfig>{
      backend: {
        occ: {
          baseUrl: environment.OCC_BASE_URL,
          prefix: environment.PREFIX,
        },
        media: {
          baseUrl: environment.MEDIA_BASE_URL,
        },
      },
    }),
    provideConfig(<AuthConfig>{
      authentication: {
        client_id: environment.AUTH_CLIENT_ID,
      },
    }),
    provideConfig(<SiteContextConfig>{
      context: {
        baseSite: [environment.BASE_SITE],
        urlParameters: ['baseSite', 'language', 'currency'],
        language: [environment.LANGUAGE],
        currency: [environment.CURRENCY],
      },
    }),
    provideConfig(<I18nConfig>{
      i18n: {
        resources: { en: translationsEn },
        chunks: translationChunksConfig,
        fallbackLang: 'en',
      },
    }),
    provideConfig(<FeaturesConfig>{
      features: {
        level: '221121.10',
      },
    }),
    {
      provide: SeoMetaService,
      useExisting: CustomSeoMetaService,
    },
  ],
})
export class SpartacusConfigurationModule {}
